import React, { Component } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Select,
  MenuItem,
  TextareaAutosize,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import {
  ContentAlertIssueType,
  ContentAlertIssueTypeList,
  ContentAlertStatus,
  ContentAlertType,
} from "./Const";

export default class ContentAlert extends Component {
  constructor(props) {
    super();

    this.state = {
      alert: ContentAlertIssueType.METADATA,
      notes: "",
      errors: null,
      errorMessage: null,
    };
  }

  handleValChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onCreate = () => {
    const { postItemCA, validateCA, DialogClose, type, source, action } = this.props

    let data = {
      alert: this.state.alert,
      notes: this.state.notes,
    };

    this.setState({ errors: null }, () => {
      validateCA(data, (error) => {
        if (!error) {
          data = {
            ...data,
            type: type,
            sourceId: source.id,
            linkId: type === ContentAlertType.TRACK ? source.id : source.prodId,
            title:
              type === ContentAlertType.TRACK
                ? source.trackTitle
                : source.prodName,
            status: ContentAlertStatus.ALERTED,
            artist: type === ContentAlertType.TRACK ? ( source?.performer && Array.isArray(source.performer) ? source?.performer?.join(", ") : source?.performer) : source?.prodArtist,
            sourceDetails: source,
          };
  
          postItemCA(action ? action : "save", "Creating content alert in progress ...", { cAlert: data }, (data, error) => {
            if (error) {
              this.setState({
                errors: { e: "Error creating content alert." },
              });
            } else {
              if (data.id) { 
                this.setState({ errors: null }, () => {
                  DialogClose(true);
                });
              }
            }
          });
  
  
  
        } else {
          this.setState({ errors: error });
          return;
        }
      });
    });

  };

  render() {
    const {
      DialogOpen,
      DialogClose,
      classes,
      contentAlertData: { posting : {busy} },
      type,
      source,
    } = this.props;

    const { alert, notes, errors } = this.state;

    return (
      <Dialog
        open={DialogOpen}
        id="content-alert-dialog"
        aria-labelledby="content-alert-dialog"
        className={classes.dialogWrapper}
        class="dialogBox"
      >
        <div className={classes.dialogMinWidth}>
          <DialogTitle id="alert-dialog-title">
            <div className={classes.modalContentHeader}>
              <div className={classes.modalContentTitle}>
                Content Alert - { type === ContentAlertType.TRACK ? source.trackTitle : source.prodName }
              </div>
              <Button
                aria-label="Close Content Request"
                className={clsx(classes.closeButton)}
                title="Close"
                onClick={() => {
                  DialogClose(false);
                }}
              >
                <CloseIcon />
              </Button>
            </div>
          </DialogTitle>
          <DialogContent  className={classes.modalContentWidth}>
            <div className={classes.modalMsgContentInner}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <div
                    className={clsx(
                      classes.globalContentCreate,
                      classes.globalContentCreateAddPadding
                    )}
                  >
                    <label
                      className={classes.globalCreateLabel}
                      aria-label="Select field for alert type"
                    >
                      Alert :{" "}
                    </label>
                    <Select
                      id="alert"
                      key="alert"
                      name="alert"
                      variant="outlined"
                      aria-label={"Select content alert type"}
                      inputProps={{
                        id: "alertType",
                        "aria-labelledby": "alertType",
                        "aria-label": "Select content alert type",
                      }}
                      autoFocus
                      className={classes.contentHelpDropdown}
                      fullWidth
                      value={alert}
                      onChange={this.handleValChange}
                    >
                      {ContentAlertIssueTypeList.map((opt) => (
                        <MenuItem key={opt.id} value={opt.id}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>

                  <div  className={clsx(
                      classes.globalContentCreate,
                      classes.globalContentCreateAddPadding,
                      classes.globalContentCreateAddBottomPadding
                    )}>
                    <label
                      className={classes.globalCreateLabel}
                      aria-label="Input field for notes"
                    >
                      Notes
                      <span
                        aria-label="alert note required"
                        className={classes.reqSymbol}
                      >
                        *
                      </span>{" "}
                      :{" "}
                    </label>
                    <div
                      className={clsx(
                        classes.composeTextAreaContReq,
                        this.state.errors && this.state.errors["notes"]
                          ? classes.emptyData
                          : null
                      )}
                    >
                      <TextareaAutosize
                        rowsMax={10}
                        value={notes || ""}
                        name="notes"
                        aria-label={"Notes"}
                        onChange={this.handleValChange}
                      />
                      {this.state.errors && this.state.errors["notes"] && (
                        <span>{this.state.errors["notes"]}</span>
                      )}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
          <DialogActions className={classes.dialogSubmitButton}>
            {errors && errors.e && (
              <Typography role="alert" variant="body2" className={classes.customError}>
                {errors.e}
              </Typography>
            )}
            <Button
              className={clsx(classes.dialogYesButton)}
              onClick={(e) => {
                this.onCreate();
              }}
              color="primary"
              autoFocus
            >
              Create
              {busy && (
                <CircularProgress size={20} className={classes.Alertprogress} />
              )}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    );
  }
}
